import React from 'react'
import BgShadow from "./Shadow"
import PatternVertical from '@/components/pattern/Patternvertical';

const Pattern = ({ classNameBase = "", className = "", disableShadow, disablePatttern }: { classNameBase?: string, className?: string, disableShadow?: boolean, disablePatttern?: boolean }) => {
    return (
        <div className={(disablePatttern ? '' : '') + " relative -z-10 " + classNameBase}>
            {!disablePatttern &&
                <div className={' fixed left-0 top-0 w-full'}>
                    <PatternVertical className={className + ' h-screen w-full'} />
                </div>
            }
            {!disableShadow &&
                <div className=' fixed flex items-center justify-center h-screen w-full top-0 left-0'>
                    <div className=' fixed top-0 right-0'>
                        <BgShadow />
                    </div>
                    <div className=' fixed -bottom-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 opacity-75'>
                        <BgShadow />
                    </div>
                </div>
            }
        </div>
    )
}

export default Pattern
